<script>
import { Modal } from "bootstrap";
import { useCourseDataStore } from "@/stores/course/course-data-store.js";

export default {
  data() {
    return {};
  },
  setup() {
    const CourseDataStore = useCourseDataStore();

    return {
      CourseDataStore,
    };
  },
  computed: {
    isEditMode() {
      return !!this.CourseDataStore.selectedGroupId;
    },
    modalTitle() {
      return this.isEditMode ? "Edit Group" : "Add Group";
    },
  },
  methods: {
    submitGroup() {
      if (this.CourseDataStore.selectedGroupId) {
        this.CourseDataStore.updateGroup(this.CourseDataStore.selectedGroupId);
      } else {
        this.CourseDataStore.createGroup();
      }

      // Tutup modal dengan aman
      const modalEl = document.getElementById("addGroupModal");
      if (modalEl) {
        // Pastikan modal sudah di-instantiate oleh Bootstrap
        let modalInstance = Modal.getInstance(modalEl);
        if (!modalInstance) {
          modalInstance = new Modal(modalEl); // Inisialisasi jika belum
        }
        modalInstance.hide();
      }
    },
  },
};
</script>

<template>
  <div class="modal fade" id="addGroupModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="isax isax-close-circle5"></i>
          </button>
        </div>
        <form @submit.prevent="submitGroup">
          <div class="modal-body">
            <input
              v-model="CourseDataStore.courseGroupForm.code"
              class="form-control mb-2"
              placeholder="Code"
            />
            <input
              v-model="CourseDataStore.courseGroupForm.name"
              class="form-control mb-2"
              placeholder="Name"
            />
            <textarea
              v-model="CourseDataStore.courseGroupForm.description"
              class="form-control"
              placeholder="Description"
            ></textarea>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary mx-1">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
